import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "required", "maxlength", "minlength", "rows", "autocomplete"];
import { ref, watch, computed } from "vue";
import log from "../../services/Logger";
import { autocompleteAttr } from "./FormUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlTextarea',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const model = ref(createModel());
        const fieldOptions = props.field.options || {};
        const autocomplete = computed(() => {
            return autocompleteAttr(fieldOptions);
        });
        function createModel() {
            if (props.data === null || props.data === undefined) {
                return undefined;
            }
            else if (typeof props.data === 'string') {
                return props.data;
            }
            else {
                return "" + props.data;
            }
        }
        // changes from the outside
        watch(() => props.data, () => model.value = createModel());
        // changes from the inside
        function onChange() {
            const value = model.value;
            log('FieldControlTextarea@change', props.field.name, value);
            emit('change', value);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onInput: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                maxlength: _unref(fieldOptions).maxLength ?? undefined,
                minlength: _unref(fieldOptions).minLength ?? undefined,
                rows: _unref(fieldOptions).rows ?? undefined,
                autocomplete: autocomplete.value,
                class: _normalizeClass(["form__control", 'form__control--' + __props.field.type])
            }, null, 42, _hoisted_1)), [
                [
                    _vModelText,
                    model.value,
                    void 0,
                    { trim: true }
                ]
            ]);
        };
    }
});
